import { useState } from "react";
import {
  handleChange,
  handleSignInSubmit,
  signInInitial,
} from "../ah1/ah1.utils";
import "./aho1-signin.styles.scss";
const AHO1SignIn = () => {
  const [signinFields, setSignInFields] = useState(signInInitial);
  const [loaderClass, setLoaderClass] = useState("aho1-loader-hidden");
  const { email, password } = signinFields;
  return (
    <div className="signin-form-container">
      <div className={loaderClass}>
        <div className="loader"></div>
      </div>
      <form
        onSubmit={(event) =>
          handleSignInSubmit(event, signinFields, setLoaderClass)
        }
        className="signin-form"
      >
        <input
          type="text"
          name="email"
          value={email}
          placeholder="E-mail or Phone"
          onChange={(event) =>
            handleChange(event, signinFields, setSignInFields)
          }
          className="ah-one-input"
        />
        <input
          type="password"
          name="password"
          value={password}
          placeholder="Password"
          onChange={(event) =>
            handleChange(event, signinFields, setSignInFields)
          }
          className="ah-one-input"
        />
        <button type="submit" className="ah-one-submit">
          Sign In
        </button>
      </form>
    </div>
  );
};
export default AHO1SignIn;
